import { useCallback, useContext } from "react"

import { ContributionLimit, ContributionLimitCollection, Index } from "wealthmode-frontend/backend"
import { Box, HStack } from "wealthmode-frontend/gluestack/ui"
import { formatMoneyFull } from "wealthmode-frontend/util"

import { DataTable, IDLink } from "@/components"
import { BackendContext } from "@/context"
import { contributionLimitKindLabel } from "@/lib/labels"

export default function ContributionLimits() {
  const backend = useContext(BackendContext)

  const load = useCallback(async () => {
    const data = backend.link("data").resolve() as Index
    await data.fetch({ reload: true })

    const limits = data.link("contribution_limits")?.resolve() as ContributionLimitCollection | undefined
    if (!limits) {
      return undefined
    }

    await limits.fetch({ reload: true })

    return limits
  }, [backend])

  return (
    <Box>
      <HStack>
        <Box className="flex-1">
          <DataTable
            title={"Contribution Limits"}
            load={load}
            header={[
              { id: "id", title: "ID", shrink: true },
              { id: "tax_year", title: "Tax Year", shrink: true },
              { id: "kind", title: "Kind" },
              { id: "filing_status", title: "Filing Status" },
              { id: "maximum", title: "Maximum" },
            ]}
            render={(model: ContributionLimit, field: string) => {
              switch (field) {
                case "id":
                  return (
                    <IDLink
                      href={`/contribution_limits/${model.id}`}
                      id={model.id}
                    />
                  )

                case "kind":
                  return contributionLimitKindLabel(model.attributes.kind)

                // A limit with no filing status applies whatever the status.
                case "filing_status":
                  return model.attributes.filing_status ?? "Any"

                case "maximum":
                  return formatMoneyFull(model.attributes.maximum)
              }

              return model.get(field)
            }}
          />
        </Box>
      </HStack>
    </Box>
  )
}
